import Vue from 'vue'
import Router from 'vue-router'

/* layouts */
import Layout from '../views/layout/layoutMain'

const _import = require('./_import_' + process.env.NODE_ENV)

const authorPath = process.env.authorPath

const leftMenuParent = authorPath ? '/' + authorPath : authorPath

Vue.use(Router)
export const leftNavRouter = [

	{
		path: 'booklist',
		component: _import('bookManage/bookList'),
		name: 'booklist',
		icon: 'th-large',
		parent: leftMenuParent,
		meta: {
			title: '作品管理',
			activeNav: 'booklist'
		},
	},

	{
		path: 'bookData',
		component: _import('bookData/index'),
		name: 'bookData',
		icon: 'bar-chart',
		parent: leftMenuParent,
		meta: {
			title: '作品数据',
			activeNav: 'bookData'
		},
		redirect: leftMenuParent + '/bookData',
		children: [
			{
				path: '/',
				component: _import('bookData/bookData'),
				name: '',
				meta: {
					activeNav: 'bookData'
				}
			}, {
				//首页书籍跳转
				path: 'only/:bookId',
				component: _import('bookData/bookData'),
				name: 'bookDataOnly',
				meta: {
					activeNav: 'bookData'
				}
			}, {
				//稿费收入详情跳转
				path: 'link/:info',
				component: _import('bookData/bookData'),
				name: 'bookDataLink',
				meta: {
					activeNav: 'bookData'
				}
			}, {
				path: 'viewDetails/:bookId/:date',
				component: _import('bookData/viewDetails'),
				name: 'viewDetails',
				meta: {
					title: '数据详情',
					activeNav: 'bookData'
				},
			}]
	},
	{
		path: 'income',
		name: 'income',
		component: _import('income/index'),
		icon: 'cny',
		parent: authorPath,
		meta: {
			title: '稿费收入',
			activeNav: 'income'
		},
		redirect: leftMenuParent + '/income',
		children: [
			{
				path: '/',
				component: _import('income/income'),
				name: '',
				meta: {
					activeNav: 'income'
				}
			}, {
				path: 'only/:bookId',
				component: _import('income/income'),
				name: 'incomeOnly',
				meta: {
					activeNav: 'income',
				},
			}, {
				path: 'balanceDetails',
				component: _import('income/balanceDetails'),
				name: 'balanceDetails',
				meta: {
					title: '账户余额',
					activeNav: 'income',
				},
			}, {
				path: 'incomeDetails/:bookId/:date',
				component: _import('income/incomeIndex'),
				name: 'incomeDetails',
				parent: '/income',
				meta: {
					title: '稿费详情',
					activeNav: 'incomeDetails',
				},
				redirect: leftMenuParent + '/income/incomeDetails/:bookId/:date',
				children: [{
					path: '/',
					component: _import('income/incomeDetails'),
					name: '',
				}, {
					path: 'allDetails',
					component: _import('income/allDetails'),
					name: 'allDetails',
					meta: {
						title: '全勤详情',
						activeNav: 'income',
					},
				}]
			}]
	},
	{
		path: 'benefitApply',
		component: _import('benefitApply/benefitApply'),
		name: 'benefitApply',
		icon: 'file-text',
		parent: leftMenuParent,
		meta: {
			title: '福利申请'
		},
	},
	{
		path: 'voteManage',
		component: _import('voteManage/index'),
		name: 'voteManage',
		icon: 'signal',
		parent: leftMenuParent,
		meta: {
			title: '投票管理',
			activeNav: 'voteManage',
		},
		redirect: leftMenuParent + '/voteManage',
		children: [{
			path: '/',
			component: _import('voteManage/voteManage'),
			name: '',
			meta: {
				activeNav: 'voteManage',
			},
		}, {
			path: 'voteCreate',
			component: _import('voteManage/voteCreate'),
			name: 'voteCreate',
			meta: {
				title: '创建投票',
				activeNav: 'voteManage'
			},
		}, {
			path: 'voteRules',
			component: _import('voteManage/voteRules'),
			name: 'voteRules',
			meta: {
				title: '作家专区投票规则功能说明',
				activeNav: 'voteManage'
			},
		}]
	},
	{
		path: 'activities',
		component: _import('activities/activities'),
		name: 'activities',
		icon: 'gift',
		parent: leftMenuParent,
		meta: {
			title: '活动专区'
		},
	},
	{
		path: 'news',
		name: 'news',
		component: _import('news/index'),
		icon: 'newspaper-o',
		parent: leftMenuParent,
		meta: {
			title: '新闻公告',
			activeNav: 'news',
		},
		redirect: leftMenuParent + '/news',
		children: [{
			path: '/',
			component: _import('news/news'),
			name: '',
			meta: {
				activeNav: 'news',
			},
		}, {
			path: 'newsDetails/:id',
			component: _import('news/newsDetails'),
			name: 'newsDetails',
			meta: {
				title: '新闻公告详情',
				activeNav: 'news'
			},
		}]
	},
	{
		path: 'notices',
		component: _import('notices/notices'),
		name: 'notices',
		icon: 'bell-o',
		parent: leftMenuParent,
		meta: {
			title: '消息通知'
		},
	},
	{
		path: 'commonQuestion',
		component: _import('commonQuestion/commonQuestion'),
		name: 'commonQuestion',
		icon: 'question-circle-o',
		parent: leftMenuParent,
		meta: {
			title: '常见问题'
		},
	}

]

export default new Router({
	mode: 'history',
	routes: [
		{
			path: leftMenuParent + '/contract',
			name: 'contract',
			component: _import('authorInfo/contract'),
		},
		{
			path: leftMenuParent,
			name: '作家专区',
			component: Layout,
			redirect: leftMenuParent + '/index',
			children: [
				{
					path: '/',
					redirect: leftMenuParent + '/index'
				},
				{
					path: 'index',
					component: _import('home/index'),
					name: 'index',
					icon: 'el-icon-menu'
				},

				...leftNavRouter,

				{
					path: 'manage/:id',
					component: _import('bookManage/bookManageLayout'),
					meta: {
						title: '作品管理',
						activeNav: 'booklist'
					},
					redirect: 'manage/:id/bookInfo',
					children: [

						{
							path: 'bookInfo',
							component: _import('bookManage/info'),
							name: 'bookInfo',
							meta: {
								title: '作品名称',
								activeNav: 'booklist'
							},
						}, {
							path: 'chapterPublished',
							component: _import('bookManage/chapterPublished'),
							name: 'chapterPublished',
							meta: {
								title: '作品名称',
								activeNav: 'booklist'
							},
						}, {
							path: 'draft',
							component: _import('bookManage/draft'),
							name: 'draft',
							meta: {
								title: '作品名称',
								activeNav: 'booklist'
							},
						}, {

							path: 'addChapter',
							component: _import('bookManage/addChapter'),
							name: 'addChapter',
							meta: {
								title: '作品名称',
								activeNav: 'booklist'
							},
						},

					]

				},

				{
					path: 'bookSign',
					component: _import('bookManage/bookSign'),
					meta: {
						title: '作品管理',
						activeNav: 'booklist'
					},
					children: [
						{
							path: '/',
							meta: {
								title: ' ',
								sign: true
							},
							children: [
								{
									path: leftMenuParent+'/bookSign/:bookId',
									// component: _import('bookManage/bookSign'),
									name: 'bookSign',
									meta: {
										title: '申请签约',
										activeNav: 'bookSign'
									},
								},
							]
						},
					]

				},//申请签约
				{
					path: 'basic',
					component: _import('authorInfo/basic'),
					name: 'basic',
					meta: {
						title: '基本信息'
					},
				},
				{
					path: 'modifyInfo/:userId',
					component: _import('authorInfo/modifySign'),
					name: 'modifyInfo',
					meta: {
						title: '修改签约信息'
					},
				},
				{
					path: 'accountBind',
					component: _import('authorInfo/accountBind'),
					name: 'accountBind',
					meta: {
						title: '账号绑定'
					},
				},
				{
					path: 'addBook',
					component: _import('bookManage/addBook'),
					name: 'addBook',
					meta: {
						title: '新建作品'
					},

				},
				{
					path: 'login',
					name: 'login',
					components: {login: _import('login/main')}
				},

				{
					path: 'register',
					name: 'register',
					components: {login: _import('register/main')}
				},
				{
					path: 'contract',
					name: 'contract',
					component: _import('authorInfo/contract'),
					// redirect: leftMenuParent + '/contract',
				},
                {
                    path: 'completionInfo',
                    component: _import('bookManage/completionInfo'),
                    name: 'completionInfo',
                    meta: {
                        title: '补全信息',
                    },
                },
				{path: '*', component: _import('errorPage/404')},
			]
		},

	],
	scrollBehavior(to, from, savedPosition) {
		return {x: 0, y: 0}
	}
})



// WEBPACK FOOTER //
// ./src/router/index.js